import { IAppConfig } from '@/data/config/types'
import Link from 'next/link'
import { ReactNode } from 'react'
import { ExternalLink } from 'react-feather'

function Shortcuts({ appConfig }: { appConfig: IAppConfig }): ReactNode {
  return (
    <div className=" bg-gray-100">
      <div className="relative">
        <div className="content-sidebar relative flex !justify-start gap-2 py-2 px-4 md:px-8 lg:px-0 overflow-x-auto w-full lg:py-3 scrollbar-x-none pr-8">
          {appConfig.main_shortcuts.map((shortcut) => (
            <Link
              key={`shortcut-${shortcut.id}`}
              href={shortcut.href || '#'}
              title={shortcut.title}
              target={shortcut.target}
              className="rounded border flex gap-1 items-center bg-white whitespace-nowrap px-2 font-semibold text-sm uppercase shadow-sm h-6 hover:bg-white hover:text-primary hover:border-primary active:bg-bodyColor active:text-body"
              // scroll={false}
            >
              {shortcut.name}
              {shortcut.target === '_blank' ? (
                <ExternalLink className="w-3 -mt-1" />
              ) : (
                ''
              )}
            </Link>
          ))}
        </div>
        <div className="absolute right-0 top-0 w-12 flex bottom-0 pointer-events-none">
          <div className="w-2/3 h-full bg-gradient-to-r from-transparent to-gray-100"></div>
          <div className="flex-grow h-full bg-gray-100"></div>
        </div>
      </div>
    </div>
  )
}

export default Shortcuts
